export const env = {
    BASE_URL : '/tritikbdb',
    BACKEND : 'https://bioinfo.usu.edu/wheatbackend'
}
